import React, { FC, useState } from "react";

import { useSound } from "../../../hooks";

import emotionalDeck from "../../../assets/cards/emotional_deck.svg";
import socialDeck from "../../../assets/cards/social_deck.svg";
import mentalDeck from "../../../assets/cards/mental_deck.svg";
import physicalDeck from "../../../assets/cards/physical_deck.svg";
interface DeckProps {
    type: string;
    onDraw(): void;
}

const Deck: FC<DeckProps> = ({ type, onDraw }) => {
    let [isDillemaDoubleClicked, setIsDillemaDoubleClicked] = useState(0);
    const {playSound} = useSound();
    
    const getRandomCard = () => {
        onDraw();
        playSound("/sounds/LightClick.mp3");
    };

    const getSolutionDeckDeckType = () => {
        switch (type) {
            case "emotional": return emotionalDeck; 
            case "social": return socialDeck;
            case "mental": return mentalDeck; 
            case "physical": return physicalDeck;
        }
    }

    if (type === "action" || type === "question") {
        return (
            <React.Fragment>
                <div className="decks cursor_pointer" onClick={()=>{
                    setIsDillemaDoubleClicked(isDillemaDoubleClicked++)
                    if(isDillemaDoubleClicked ==2 ){
                        getRandomCard();
                    }

                    }} />
            </React.Fragment>
        )
    }

    return (
        <React.Fragment>
            <img className="solution_deck_image" src={getSolutionDeckDeckType()} alt="emotional" onClick={getRandomCard} />
        </React.Fragment>
    );
};

export default Deck;